import { type Ancillary, type PrescriptionsWithAncillaries } from '~shared/features/my-meds/types';
/* A helper function to get a prescription with ancillaries from the state, 
  after that, transform the object to the format required by suppliesList component */

type AncillarySupply = Pick<Ancillary, 'description' | 'id'>;

export const getAncillariesFromPrescription = (
  prescriptionsWithAncillaries: PrescriptionsWithAncillaries,
  prescriptionID: number | undefined,
): AncillarySupply[] => {
  const ancillaries = prescriptionsWithAncillaries[prescriptionID || ''];
  if (ancillaries) {
    return ancillaries.map((ancillary: Ancillary) => {
      return {
        description: ancillary.description,
        id: ancillary.id,
      };
    });
  }

  return [];
};
